import { Button, Flex, Link } from '@chakra-ui/react'
import ArrowRightOmens from 'components/svg/ArrowRightOmens'
import { Body1 } from 'components/typography'
import { FC } from 'react'
import { ARROW_NUDGE_ANIMATION } from 'styles/animations'

import { HOME_CTA_HREF, HOME_CTA_LABEL } from '../constants'

/**
 * Hero CTA. Same contract as the current Medleve landing: a plain anchor (full page navigation, no
 * `onClick`) to the onboarding, wrapping a button — click tracking lives in GTM, so the
 * `a[href] > button > p` shape, the href and the label must not change (PRD §8).
 * One responsive element replaces the separate mobile/desktop buttons of `MedleveHeroSection`.
 */
const HomeHeroCta: FC = () => (
  <Link
    href={HOME_CTA_HREF}
    display="block"
    w={{ base: 'full', lg: 'max-content' }}
    pt={{ base: 3, lg: 0 }}
    _hover={{ textDecoration: 'none' }}
  >
    <Button
      w={{ base: 'full', lg: '304px' }}
      h="auto"
      px={{ base: '22px', lg: '32px' }}
      py={{ base: '20px', lg: '40px' }}
      borderRadius={{ base: '22px', lg: '32px' }}
      bg={{ base: '#4774B8', lg: 'medleve' }}
      color="alabaster"
      boxShadow={{
        base: '0 10px 28px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.08), inset 0 1px 0 rgba(255,255,255,0.22)',
        lg: 'base'
      }}
      _hover={{ bg: { base: '#5A8AD4', lg: '#30496b' } }}
    >
      <Flex w="full" justify="space-between" align="center">
        <Body1
          fontWeight={800}
          fontSize={{ base: '17px', lg: '1.5rem' }}
          sx={{ fontFeatureSettings: "'ss01' on, 'liga' off, 'calt' off" }}
          letterSpacing={{ base: '-0.01em', lg: '-0.03em' }}
          lineHeight={{ base: '1.4rem', lg: '1.75rem' }}
        >
          {HOME_CTA_LABEL}
        </Body1>
        <ArrowRightOmens
          fill="alabaster"
          boxSize="18px"
          aria-hidden="true"
          sx={{ animation: { base: ARROW_NUDGE_ANIMATION, lg: 'none' } }}
        />
      </Flex>
    </Button>
  </Link>
)

export default HomeHeroCta
